import { render, staticRenderFns } from "./blxzDla.vue?vue&type=template&id=6e5e8e2b&scoped=true&"
import script from "./blxzDla.vue?vue&type=script&lang=js&"
export * from "./blxzDla.vue?vue&type=script&lang=js&"
import style0 from "./blxzDla.vue?vue&type=style&index=0&id=6e5e8e2b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5e8e2b",
  null
  
)

export default component.exports